import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { useTranslation } from "react-i18next";
import CadisButton from '../../Components/Input/CadisButton';

interface DataExhaustedDialogProps {
    isOpen: boolean;
    handleDataExhaustedPopup?: () => void;
    dataFinished?: boolean;
    dataExhausted?: boolean;
    asstDataFinished?: boolean;
}

const DataExhaustedDialog: React.FC<DataExhaustedDialogProps> = ({
    isOpen,
    handleDataExhaustedPopup,
    dataFinished,
    dataExhausted,
    asstDataFinished,
}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={isOpen}
            onClose={() => { return null }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {isOpen ? <DialogTitle id="alert-dialog-title" color="error">
                {dataFinished || asstDataFinished ? 'Data Limit Exceeded' : t('lbl_warning')}
            </DialogTitle> : ""}
            <DialogContent>
                {/* data below 10% */}
                {dataExhausted && t('lbl_dataLimitReached')}

                {/* data zero */}
                {dataFinished && t('lbl_dataExhaustedInitiateCall')}

                {/* Assistant data zero */}
                {asstDataFinished && t('lbl_asstDifferentSubscritpionDataExhausted')}
            </DialogContent>
            <DialogActions>
                <CadisButton variant="contained" color="primary" onClick={handleDataExhaustedPopup}>{t('lbl_ok')}</CadisButton>
            </DialogActions>
        </Dialog>
    );
};

export default DataExhaustedDialog;